import { useSitecoreContext } from '@liander/context';
import { Box, Text } from '@ads-core/components';
import { FilteredCongestionReportsParagraphProps } from 'components/CongestionReportsParagraph';
import { useCongestionDetails } from 'src/hooks/useCongestionDetails';
import React from 'react';
import { CongestionReportsParagraphView } from './_View';

export type CongestionReportsParagraphProps = FilteredCongestionReportsParagraphProps;

/**
 * This component should be used within a CongestionReportContainer.
 * The CongestionReportContainer will provide this component with the congestionReport.
 * getCongestionReport is added to retrieve the congestionReport incase the congestionReport is not provided.
 */
export const CongestionReportsParagraph = ({
  congestionReport,
  ...props
}: CongestionReportsParagraphProps) => {
  const { isEditor } = useSitecoreContext();
  const {
    isLoading,
    isError,
    congestionReport: data,
  } = useCongestionDetails(
    congestionReport,
    props.isLoading,
    props.isError,
    props.enableResolvedDateRange
  );

  const isNotFound = !isLoading && !data?.id && !data?.name && !data?.locations;

  // When the congestion report is not found we return null.
  if (isNotFound || isError) {
    return isEditor ? (
      <Box>
        <Text>Report not found</Text>
      </Box>
    ) : null;
  }

  return (
    <CongestionReportsParagraphView {...props} congestionReport={data} isLoading={isLoading} />
  );
};
